import { User } from 'firebase';
import { Rider } from './riders';
import React from 'react';
import { FirestoreCollection } from '@react-firebase/firestore';
import { Media, MediaContent, Content, Button, Columns, Column } from 'bloomer';
import { combineIdsAndValues, firebaseApp } from '../firebase/firebase';
import { navigateTo } from '../nav/nav-top';
import { useHistory } from 'react-router-dom';

export function Bikes({ user, rider }: { user: User; rider: Rider }) {
  const history = useHistory();
  return (
    <FirestoreCollection path={`/users/${user.uid}/bikes`} orderBy={[{ field: 'name' }]}>
      {d =>
        d.isLoading
          ? 'Loading...'
          : d.value
          ? renderBikes(user, rider, combineIdsAndValues(d), history)
          : 'No bikes found'
      }
    </FirestoreCollection>
  );
}

function renderBikes(user: User, rider: Rider, bikes: Bike[], history: ReturnType<typeof useHistory>) {
  return bikes
    .filter(bike => bike.rider === rider.id)
    .map(bike => (
      <Media key={bike.id}>
        <MediaContent>
          <Content>
            <Columns>
              <Column>
                <strong>{bike.name}</strong>
                <br />
                <small>{bike.engine}</small>
                {bike.notes && (
                  <>
                    <br />
                    <small>
                      {bike.notes.split('\n').map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                    </small>
                  </>
                )}
              </Column>
              <Column>
                <div className="buttons has-addons is-small is-right">
                  <Button
                    isPulled="right"
                    isSize="small"
                    onClick={(e: any) => navigateTo(e, history, `/bikes/${bike.id}`)}
                  >
                    Edit Bike
                  </Button>
                  <Button
                    isSize="small"
                    isColor="danger"
                    onClick={() => {
                      const result = window.confirm(
                        `Are you sure that you want to delete the bike ${bike.name} of ${rider.name}?`
                      );
                      if (result) deleteBike(user, bike);
                    }}
                  >
                    Delete Bike
                  </Button>
                </div>
              </Column>
            </Columns>
          </Content>
        </MediaContent>
      </Media>
    ));
}

function deleteBike(user: User, bike: Bike) {
  firebaseApp
    .firestore()
    .doc(`users/${user.uid}/bikes/${bike.id}`)
    .update({ deleted: true });
}

interface Bike {
  id: string;
  name: string;
  engine: '2-stroke' | '4-stroke';
  notes: string;
  rider: string;
}
